import { connect } from 'react-redux'

import { openModal } from '../../common/actions/layout'
import { getUserFavoriteCollectionID, getUserCollections, getUserCartItems } from '../../common/selectors/user'
import { createFavoriteCollection } from '../../common/actions/user/collection'
import {
  deleteBookmark,
  addBookmark
} from '../../common/actions/user/bookmark'

const mapStateToProps = (state) => {
  const {
    common: {
      currentSite
    },
    user: {
      token,
      preferences
    }
  } = state

  return {
    currentSite,
    collections: getUserCollections(state),
    cartItems: getUserCartItems(state),
    favoriteCollectionID: getUserFavoriteCollectionID(state),
    token,
    preferences
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    deleteBookmark: (collectionID, itemID, id, isFavouriteCollection) => dispatch(deleteBookmark(collectionID, itemID, id, isFavouriteCollection)),
    addBookmark: (collectionId, itemId, isFavouriteCollection) => dispatch(addBookmark(collectionId, itemId, isFavouriteCollection)),
    openModal: (data) => dispatch(openModal(data)),
    createFavoriteCollection: () => dispatch(createFavoriteCollection())
  }
}

const createSearchResultBodyContainer = component => connect(
  mapStateToProps,
  mapDispatchToProps
)(component)

export default createSearchResultBodyContainer



// WEBPACK FOOTER //
// ./client/containers/searchResultBodyContainer.js